import { render } from "./ReviewsContentRank111.vue?vue&type=template&id=84c50458&scoped=true"
const script = {}

import "./ReviewsContentRank111.vue?vue&type=style&index=0&id=84c50458&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84c50458"]])

export default __exports__